<template>
    <div
        v-if="isOpen"
        class="relative z-98"
        :aria-labelledby="titleId"
        role="dialog"
        aria-modal="true"
    >
        <!-- Backdrop -->
        <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="isOpen"
                class="fixed inset-0 bg-taupe-900/50 transition-opacity"
            ></div>
        </transition>

        <!-- Dialog -->
        <div class="fixed inset-0 z-10">
            <transition
                enter-active-class="ease-out duration-300"
                enter-from-class="opacity-0 scale-95"
                enter-to-class="opacity-100 scale-100"
                leave-active-class="ease-in duration-200"
                leave-from-class="opacity-100 scale-100"
                leave-to-class="opacity-0 scale-95"
            >
                <div
                    v-if="isOpen"
                    class="fixed inset-[5%] lg:inset-[10%] rounded-xl bg-white shadow-2xl flex flex-col overflow-hidden"
                >
                    <!-- Header -->
                    <div
                        class="flex-shrink-0 bg-sky-500 px-6 py-5 flex items-center justify-between"
                    >
                        <div class="flex items-center gap-3">
                            <button
                                v-if="showBack"
                                type="button"
                                class="rounded-md bg-sky-500 text-sky-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                @click="$emit('back')"
                            >
                                <span class="sr-only">Back</span>
                                <svg
                                    class="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="2"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </button>
                            <h2
                                :id="titleId"
                                class="text-lg font-medium text-white"
                            >
                                {{ title }}
                            </h2>
                        </div>
                        <button
                            type="button"
                            class="rounded-md bg-sky-500 text-sky-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            @click="$emit('close')"
                        >
                            <span class="sr-only">Close</span>
                            <svg
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="flex-1 overflow-y-auto">
                        <slot />
                    </div>

                    <!-- Footer -->
                    <div
                        v-if="$slots.footer"
                        class="flex-shrink-0 border-t border-taupe-100"
                    >
                        <slot name="footer" />
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script setup>
defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: '',
    },
    titleId: {
        type: String,
        default: 'wizard-title',
    },
    showBack: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['close', 'back'])
</script>
